import { useState, useEffect, useRef } from 'react'
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { FloatingWhatsApp } from 'react-floating-whatsapp'

import Home from './Home';
import Services from './Services';

import Nav from 'react-bootstrap/Nav';
import { Navbar, Container } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';

import logo from './img/logo.png';
import mgLogo from './img/mgicon.webp'

import './App.css';
import 'animate.css';

function App() {
  const [goingUp, setGoingUp] = useState(false)
  const prevScrollY = useRef(0)

  const refHome = useRef()
  const refTeam = useRef()
  const refClients = useRef()
  const refServices = useRef()
  const refContact = useRef()

  const [path, ] = useState(window.location.pathname)

  useEffect(() => {
    const loadScriptByURL = (id, url, callback) => {
      const isScriptExist = document.getElementById(id);
 
      if (!isScriptExist) {
        var script = document.createElement("script");
        script.type = "text/javascript";
        script.src = url;
        script.id = id;
        script.onload = function () {
          if (callback) callback();
        };
        document.body.appendChild(script);
      }
 
      if (isScriptExist && callback) callback();
    }
 
    // load the script by passing the URL
    loadScriptByURL("recaptcha-key", `https://www.google.com/recaptcha/api.js?render=6Lfay-sgAAAAAKMr9fFh6dAgAQ72hqP64TVuAAk5`, function () {
      console.log("Script loaded!");
    });
  }, []);

  useEffect(() => {

    const handleScroll = () => {
      const currentScrollY = window.scrollY;
      var prevScrollYTemp = prevScrollY.current;
      
      if (prevScrollY.current < currentScrollY && goingUp) {
        setGoingUp(false);
      }
      if (prevScrollY.current > currentScrollY && !goingUp) {
        setGoingUp(true);
      }

      prevScrollY.current = currentScrollY;

      if(currentScrollY > 10) {
        document.getElementById("mg-navbar").className = "bg-header navbar navbar-expand-lg navbar-dark fixed-top";
      } else {
        document.getElementById("mg-navbar").className = "bg-header-start navbar navbar-expand-lg navbar-dark fixed-top";
      }

      /*if (prevScrollYTemp < currentScrollY) {
        if ( !document.getElementById("mg-navbar").classList.contains('navbar-hidden') ) {
          document.getElementById("mg-navbar").classList.remove("navbar-show");
          document.getElementById("mg-navbar").classList.add("navbar-hidden");
        }
      } else if (prevScrollYTemp > currentScrollY) {
        if ( !document.getElementById("mg-navbar").classList.contains('navbar-show') ) {
          document.getElementById("mg-navbar").classList.add("navbar-show");
          document.getElementById("mg-navbar").classList.remove("navbar-hidden");
        }
      }*/
    };

    window.addEventListener("scroll", handleScroll, { passive: true });

    return () => window.removeEventListener("scroll", handleScroll);
  }, [goingUp]);

  const handleClick = (eventKey) => {
    console.log("eventKey", eventKey, "path", path)

    if( path === "/" ) {
      var element = eval(eventKey).current;
      var headerOffset = 90;
      var elementPosition = element.getBoundingClientRect().top;
      var offsetPosition = elementPosition + window.pageYOffset - headerOffset;

      window.scrollTo({
        top: offsetPosition,
        behavior: "smooth"
      });
    } else 
      window.location.href = "/"

    /*eval(eventKey).current.scrollIntoView({
      behavior: 'smooth',
      block: 'start'
    })*/

  };

  return (
    <>
      <div className="App">
        {<FloatingWhatsApp 
          phoneNumber="5215580947307"
          accountName="MGPublicidad"  
          className="wa-style"
          statusMessage="En linea"
          avatar={ mgLogo }
          chatMessage="Hola, ¡Bienvenido a MGPublicidad!. ¿Cómo podemos ayudarte?"
          allowClickAway
          notification={false}
        />}

        <header className='header'>
          <Container >
            <Navbar id="mg-navbar" collapseOnSelect expand="lg" className={ "bg-header-start" } variant="dark" fixed="top">
              <Container>
                <Navbar.Brand href="/">
                  <img src={logo} height="80" className="d-inline-block" />
                </Navbar.Brand>
                <Navbar.Toggle aria-controls="responsive-navbar-nav" />
                <Navbar.Collapse id="responsive-navbar-nav">
                  
                  <Nav className="me-auto"></Nav>
                  
                  <Nav onSelect={ handleClick } className='align-items-center'>
                    <Nav.Link eventKey="refHome" className="nav-link-comp font-heder">
                      INICIO
                    </Nav.Link>
                    <Nav.Link eventKey="refTeam" className="nav-link font-heder">
                      TEAM
                    </Nav.Link>
                    <Nav.Link eventKey="refServices" className="nav-link font-heder">
                      UNIDADES DE NEGOCIO
                    </Nav.Link>
                    <Nav.Link eventKey="refClients" className="nav-link font-heder">
                      CLIENTES  
                    </Nav.Link>
                    <Nav.Link eventKey="refContact" className="nav-link font-heder">
                      CONTACTO
                    </Nav.Link>
                    
                  </Nav>
                </Navbar.Collapse>
                
              </Container>
            </Navbar>
          </Container>
        </header>

        <BrowserRouter>
          <Routes>
            <Route path="/" element={ <Home refHome={ refHome } refTeam={ refTeam } refServices={ refServices } refClients={ refClients } refContact={ refContact } /> } />
            <Route path="*" element={ <Services service={ path }/> } />
          </Routes>
        </BrowserRouter>

      </div>

    </>
  );
}

export default App;
